function Resume() {
    return (
      <section id="resume">
        <h2>📄 Resume</h2>
        <a
          href="/Uma_Rajagopal_Resume.pdf"
          download
          className="download-btn"
        >
          Download Resume
        </a>
      </section>
    );
  }
  export default Resume;
  